import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", { d: "M6.733 4.122h2.525c.395 0 .714.32.714.714v7.414c0 .395-.32.715-.714.715H6.733a.715.715 0 0 1-.715-.715V4.836c0-.394.32-.714.715-.714Z" }, null, -1), l = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M4.998 15.385h6.004c.733 0 1.324-.581 1.324-1.296V3.064c0-.715-.6-1.296-1.324-1.296h-.591v-.152c0-.553-.458-1.001-1.02-1.001H6.618a1.01 1.01 0 0 0-1.02 1v.153h-.6c-.733 0-1.324.581-1.324 1.296v11.025c0 .715.6 1.296 1.324 1.296Zm5.89-1.43H5.102V3.198H7.02V2.044h1.963v1.153h1.905v10.759Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n,
  l
];
function d(h, s) {
  return t(), c("svg", o, [...r]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
